import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from './analytics';

const PageTracker = () => {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname + location.search);
    console.log(location.pathname + location.search,'urlchange')
  }, [location]);

  return null; // no UI
};

export default PageTracker;